<canvas #canvas *ngIf="!bypassSignature" width="{{width}}" height="{{height}}"></canvas>
<p class="k-form-error" *ngIf="signatureNeeded">{{ 'SIGNATURE-NEEDED' | translate }}</p>
<div *ngIf="!hiddingButtons && !bypassSignature">
    {{signedDate | date:'longDate'}}
    <div class="text-center mt-3">
        <button kendoButton (click)="clearPad()">
            {{ 'CLEAR' | translate }}
        </button>
        <button class="ml-3" *ngIf="memberName" kendoButton (click)="eSign()">
            {{ 'E-SIGN' | translate }}
        </button>
    </div>
    <div *ngIf="submitButtonKey" class="text-center mt-3">
        <button kendoButton (click)="saveSignature()" [primary]="true">
            {{ submitButtonKey | translate }}
        </button>
    </div>
</div>
<div *ngIf="bypassSignature">
    <div class="text-center mt-3">
        <button kendoButton (click)="close()" [primary]="true">
            {{ 'CLOSE' | translate }}
        </button>
    </div>
</div>